import { Validateable } from "./validateable";

export abstract class DirtyModel extends Validateable {
	public constructor(private _dirty: boolean = false) {
		super();
	}

	public set dirty(d: boolean) {
		this._dirty = d;
	}

	public get dirty(): boolean {
		return this._dirty;
	}
}
